// extracted by mini-css-extract-plugin
module.exports = {"tagsPage":"TagsPage_tagsPage__1m7-s","tagsEditBlock":"TagsPage_tagsEditBlock__2nQCw"};